import React from 'react';
import { Section } from './ui/Section';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Eliges tu habilidad',
    desc: 'Lead gen, appointment setting o closer.'
  }, {
    num: '02',
    title: 'Sigues el sistema',
    desc: 'Oferta, outreach y cierre con scripts exactos.'
  }, {
    num: '03',
    title: 'Ejecutas 90 días',
    desc: 'Hasta generar $3K–$10K/mes o tener claridad total.'
  }];
  return <Section data-id="element-77">
      <h2 className="text-4xl md:text-6xl font-bold text-center mb-16 uppercase" data-id="element-78">
        Cómo funciona (en 3 pasos)
      </h2>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-79">
        {steps.map((step, idx) => <div key={idx} className="relative p-6 border-l-4 border-black pl-8" data-id="element-80">
            <div className="text-6xl font-black text-gray-100 absolute -top-4 left-4 -z-10 select-none" data-id="element-81">
              {step.num}
            </div>
            <h3 className="text-2xl font-bold mb-2 uppercase" data-id="element-82">{step.title}</h3>
            <p className="text-lg text-gray-600" data-id="element-83">{step.desc}</p>
          </div>)}
      </div>

      <div className="mt-16 text-center border-t border-b border-gray-200 py-8" data-id="element-84">
        <p className="text-xl md:text-2xl font-serif italic text-gray-800" data-id="element-85">
          "Sin apps nuevas. Sin rituales raros. Sin motivación diaria."
        </p>
      </div>
    </Section>;
}